import styled from "./HeaderButton.module.css";

const HeaderButton = function (props) {
  return (
    <button className={styled.button} onClick={props.onClick}>
      <span>{props.text}</span>
    </button>
  );
};

export default HeaderButton;
